// extracted by mini-css-extract-plugin
export default {"popupContent":"ClubAccessRestrictionPopup_popupContent__rN02l","description":"ClubAccessRestrictionPopup_description__RAv6j","link":"ClubAccessRestrictionPopup_link__u1GwF"};